export const modifyLinksInPage = (): void => {
  const isMobileParam = 'isMobileApp=1'

  const pageUrl = globalThis.window.location.href

  const links = document?.querySelectorAll('a')

  links.forEach((link) => {
    const href = link.getAttribute('href')
    if (href) {
      try {
        const linkUrl = new URL(href, pageUrl)

        if (linkUrl.search.includes(isMobileParam)) {
          return
        }

        const searchParams = new URLSearchParams(linkUrl.search)
        searchParams.set('isMobileApp', '1')

        linkUrl.search = searchParams.toString()

        link.setAttribute('href', linkUrl.toString())
      } catch (error) {
        console.error(error)
      }
    }
  })
}
